import Button from '@mui/material/Button';

const ExportStatCSV = ({ data, oper, chosenDate, err }) => {
    const downloadCSV = () => {
     
        console.log("Exporting!");
        console.log(oper);
        console.log(err);

        console.log("Starting");
      const csvString = [
        ["Referent", "Datum", 
            'AUTOK', 'RK', 'RSU', 'RDU', 'RSS', 
            'BFI', 'BFD', 'BFU', 'BRI', 'BRD', 
            'BRU', 
            'ZFI',
            'ZFD', 'ZFU', 
             'BZC', 'ZRI', 
            'ZRD', 'ZRU',
            'MATP_CHECK', 'MATPI', 'MATPD',  'MATPU', 'ACH'
            ], 
        ...data.map(item => [item.Referent, item.Datum, 
            item.AUTOK, item.RK, item.RSU, item.RDU, item.RSS,
            item.BFI, item.BFD, item.BFU, item.BRI, 
            item.BRD, 
            item.BRU, 
            item.ZFI,
            item.ZFD, item.ZFU, 
            item.BZC, 
            item.ZRI, item.ZRD,
            item.ZRU, 
            item.MATP_CHECK, item.MATPI,
            item.MATPD, item.MATPU, item.ACH
        ]) 
      ]
      .map(row => row.join(","))
      .join("\n");
  
  
      const universalBOM = "\uFEFF";
      const csv = universalBOM + csvString;
      //const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8' });
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });

     
  

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');


      //const universalBOM = "\uFEFF";
      //link.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM+csvString));


      link.href = url;
      let fName = '';
      if(oper && oper.naziv && oper.naziv!=''){
            fName = fName + oper.naziv;
      }
      if(err && err.naziv && err.naziv!=''){
            if(fName != ''){
                    fName = fName + '_' + err.naziv.replace(/ /g, '');
            } else {
                    fName = err.naziv.replace(/ /g, ''); 
            }
            
      }
      console.log("Date");
      console.log(chosenDate)
      if(chosenDate && chosenDate!=''){

            console.log("Date is?");
            console.log(chosenDate);

            let checkedNew = chosenDate.split('.').join("");

            console.log(checkedNew);

            fName = fName + "_" + checkedNew;

      }else {
            console.log("Nije odabran datum!");
      }

      console.log(fName);

      if(fName != ''){

            fName = fName + '.csv';
      } else {

            fName = 'download.csv';
      }


      link.download = fName || 'download.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    };
  
    return <Button sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="info" 

                    onClick={() => {

                        console.log("Calling export!!!");

                        downloadCSV();

                    }}
             
                    >
                    Spremi u datoteku
            </Button>
    //return <button onClick={downloadCSV}>Spremi datoteku</button>;
  };
  
  export default ExportStatCSV;